import AccentButton from '@components/ui/AccentButton';
import { Paper, Typography } from '@material-ui/core';

const ServiceCard = ({
  title,
  description,
  buttonText,
  buttonLink,
  imagePlaceholder = true,
  imageSrc,
  imageAlt = '',
  isRtl = false,
  priceRange,
}) => {
  return (
    <Paper
      className="transition-all duration-300 bg-white hover:shadow-xl h-full flex flex-col"
      elevation={2}
      style={{ boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)' }}
    >
      {imageSrc ? (
        <div className="m-4 h-48 flex-shrink-0 rounded-md overflow-hidden bg-stone-100 flex items-center justify-center">
          <img
            src={imageSrc}
            alt={imageAlt || title}
            className="max-w-full max-h-full object-contain"
            loading="lazy"
          />
        </div>
      ) : (
        imagePlaceholder && <div className="m-4 h-48 bg-gray-200 flex-shrink-0 rounded-md" />
      )}
      <div
        className={`px-6 pb-6 flex flex-col flex-grow gap-2 ${isRtl ? 'text-right' : 'text-left'}`}
      >
        <Typography variant="h5" component="h3" className="mb-8 !font-bold">
          {title}
        </Typography>
        <Typography variant="body2" className="mb-4 text-black leading-relaxed flex-grow">
          {description}
        </Typography>
        {priceRange && (
          <Typography variant="body2" className="mb-4 text-stone-700 font-bold">
            {priceRange}
          </Typography>
        )}
        <div className={`${isRtl ? 'text-right' : 'text-left'} mt-auto`}>
          <AccentButton
            to={buttonLink}
            variant="contained"
            size="medium"
            className="px-6 py-2.5 inline-block"
          >
            {buttonText}
          </AccentButton>
        </div>
      </div>
    </Paper>
  );
};

export default ServiceCard;
